import axios from "axios";
import {
  FETCH_DASHBOARD_STATS_SUCCESS_Q1,
  FETCH_DASHBOARD_STATS_FAIL_Q1,
  FETCH_DASHBOARD_STATS_LOADING_Q1,
  FETCH_DASHBOARD_STATS_SUCCESS_Q2,
  FETCH_DASHBOARD_STATS_FAIL_Q2,
  FETCH_DASHBOARD_STATS_LOADING_Q2,
  FETCH_DASHBOARD_STATS_SUCCESS_Q3,
  FETCH_DASHBOARD_STATS_FAIL_Q3,
  FETCH_DASHBOARD_STATS_LOADING_Q3,
  FETCH_RECIPES_STATS_SUCCESS, 
  FETCH_RECIPES_STATS_FAIL,
  FETCH_RECIPES_STATS_LOADING,
  FETCH_CUSTOM_RECIPES_STATS_SUCCESS, 
  FETCH_CUSTOM_RECIPES_STATS_FAIL,
  FETCH_CUSTOM_RECIPES_STATS_LOADING,
  FETCH_RECIPES_STATS_WITH_PARAMS_SUCCESS,
  FETCH_RECIPES_STATS_WITH_PARAMS_FAIL,
  FETCH_RECIPES_STATS_WITH_PARAMS_LOADING,
  FETCH_DEVICE_RECIPES_STATS_SUCCESS,
  FETCH_DEVICE_RECIPES_STATS_FAIL,
  FETCH_DEVICE_RECIPES_STATS_LOADING,
  FETCH_CURATED_RECIPES_TILE_SEARCH_SUCCESS,
  FETCH_CURATED_RECIPES_TILE_SEARCH_FAIL,
  FETCH_CURATED_RECIPES_TILE_SEARCH_LOADING,
  FETCH_INGREDIENTS_TILE_SEARCH_SUCCESS,
  FETCH_INGREDIENTS_TILE_SEARCH_FAIL,
  FETCH_INGREDIENTS_TILE_SEARCH_LOADING,
  FETCH_BRANDS_TILE_SEARCH_LOADING,
  FETCH_BRANDS_TILE_SEARCH_SUCCESS,
  FETCH_BRANDS_TILE_SEARCH_FAIL,
  FETCH_INFLUENCERS_TILE_SEARCH_LOADING,
  FETCH_INFLUENCERS_TILE_SEARCH_SUCCESS,
  FETCH_INFLUENCERS_TILE_SEARCH_FAIL,
  FETCH_INFLUENCER_RECIPES_LOADING,
  FETCH_INFLUENCER_RECIPES_SUCCESS,
  FETCH_INFLUENCER_RECIPES_FAIL,
  FETCH_CURATED_RECIPES_V3_LOADING,
  FETCH_CURATED_RECIPES_V3_SUCCESS,
  FETCH_CURATED_RECIPES_V3_FAIL,
  FETCH_INGREDIENTS_V3_LOADING,
  FETCH_INGREDIENTS_V3_SUCCESS,
  FETCH_INGREDIENTS_V3_FAIL,
  FETCH_STATS_DATA_JSON_LOADING,
  FETCH_STATS_DATA_JSON_SUCCESS,
  FETCH_STATS_DATA_JSON_FAIL,
  FETCH_COUNTRY_DATA_JSON_LOADING,
  FETCH_COUNTRY_DATA_JSON_SUCCESS,
  FETCH_COUNTRY_DATA_JSON_FAIL,
  FETCH_SOURCE_DATA_JSON_LOADING,
  FETCH_SOURCE_DATA_JSON_SUCCESS,
  FETCH_SOURCE_DATA_JSON_FAIL,
  FETCH_PRODUCT_DATA_JSON_LOADING,
  FETCH_PRODUCT_DATA_JSON_SUCCESS,
  FETCH_PRODUCT_DATA_JSON_FAIL,
  FETCH_HARDWARE_CHART_TILE_INFO_LOADING,
  FETCH_HARDWARE_CHART_TILE_INFO_SUCCESS,
  FETCH_HARDWARE_CHART_TILE_INFO_FAIL,
  FETCH_BRANDS_V3_LOADING,
  FETCH_BRANDS_V3_SUCCESS,
  FETCH_BRANDS_V3_FAIL,
  FETCH_INFLUENCER_V3_LOADING,
  FETCH_INFLUENCER_V3_SUCCESS,
  FETCH_INFLUENCER_V3_FAIL,
  FETCH_COMPARE_USERS_WEEK_LOADING,
  FETCH_COMPARE_USERS_WEEK_SUCCESS,
  FETCH_COMPARE_USERS_WEEK_FAIL,
  FETCH_COMPARE_USERS_MONTH_LOADING,
  FETCH_COMPARE_USERS_MONTH_SUCCESS,
  FETCH_COMPARE_USERS_MONTH_FAIL,
  FETCH_COMPARE_USERS_YEAR_LOADING,
  FETCH_COMPARE_USERS_YEAR_SUCCESS,
  FETCH_COMPARE_USERS_YEAR_FAIL,
  FETCH_COMPARE_USERS_DAY_LOADING,
  FETCH_COMPARE_USERS_DAY_SUCCESS,
  FETCH_COMPARE_USERS_DAY_FAIL,
  FETCH_USER_RECIPES_LOADING,
  FETCH_USER_RECIPES_SUCCESS,
  FETCH_USER_RECIPES_FAIL,
  FETCH_CURATED_RECIPES_LOADING,
  FETCH_CURATED_RECIPES_SUCCESS,
  FETCH_CURATED_RECIPES_FAIL,
  FETCH_BRAND_RECIPES_LOADING,
  FETCH_BRAND_RECIPES_SUCCESS,
  FETCH_BRAND_RECIPES_FAIL,
  FETCH_PLAYLIST_MIXILISTS_LOADING,
  FETCH_PLAYLIST_MIXLISTS_SUCCESS,
  FETCH_PLAYLIST_MIXLISTS_FAIL,
  FETCH_PLAYLIST_BRANDS_LOADING,
  FETCH_PLAYLIST_BRANDS_SUCCESS,
  FETCH_PLAYLIST_BRANDS_FAIL,
  FETCH_PLAYLIST_INFLUENCERS_LOADING,
  FETCH_PLAYLIST_INFLUENCERS_SUCCESS,
  FETCH_PLAYLIST_INFLUENCERS_FAIL,
  FETCH_USER_TILE_INFO_LOADING,
  FETCH_USER_TILE_INFO_SUCCESS,
  FETCH_USER_TILE_INFO_FAIL,
  //Orders
  FETCH_ORDERS_LOADING,
  FETCH_ORDERS_SUCCESS,
  FETCH_ORDERS_FAIL,
  FETCH_ORDER_DETAILS_LOADING,
  FETCH_ORDER_DETAILS_SUCCESS,
  FETCH_ORDER_DETAILS_FAIL,
  //Crafted Cocktails Expansion
  FETCH_CRAFTED_COCKTAILS_EXPAND_LOADING,
  FETCH_CRAFTED_COCKTAILS_EXPAND_SUCCESS,
  FETCH_CRAFTED_COCKTAILS_EXPAND_FAIL,
  //Hardware Expansion
  FETCH_HARDWARE_USAGE_STATS_LOADING,
  FETCH_HARDWARE_USAGE_STATS_SUCCESS,
  FETCH_HARDWARE_USAGE_STATS_FAIL,
  //Users Expansion
  FETCH_COMPARE_USERS_LOADING,
  FETCH_COMPARE_USERS_SUCCESS,
  FETCH_COMPARE_USERS_FAIL,
} from "./types";

/**
 * period: 'day' | 'week' | 'month' | 'year'
 * limit: number of points
 */
export const fetchCompareUsers = (period, limit, loading_flag = 1) => async dispatch => {

  if (Number(loading_flag) !== 0) {
    dispatch({ type: FETCH_COMPARE_USERS_LOADING });
  }
  // dispatch({ type: FETCH_COMPARE_USERS_LOADING });

  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/compare-users`;
  try {
    const token = localStorage.getItem("jwtToken");
    const { data } = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params: { period, limit }
    });
    if (data.success) {
      dispatch({ type: FETCH_COMPARE_USERS_SUCCESS, payload: data.data });
    } else {
      dispatch({ type: FETCH_COMPARE_USERS_FAIL, payload: data.message });
    }
  } catch (err) {
    const msg = err.response?.data?.message || err.message;
    dispatch({ type: FETCH_COMPARE_USERS_FAIL, payload: msg });
  }
};


/**
 * period: 'day' | 'week' | 'month' | 'year' | 'custom'
 * limit: how many points to fetch
 * deviceType: 'coaster' | 'barsys360' | all
 * from/to: only if period === 'custom' (ISO strings)
 */
// actions/dashboard_actions.js (or wherever it lives)
// actions/dashboard_actions.js (or wherever this lives)
export const fetchHardwareUsageStats =
  (...args) => async (dispatch) => {
    dispatch({ type: FETCH_HARDWARE_USAGE_STATS_LOADING });

    // ---- Backward compatibility adapter ----
    // Support both: fetchHardwareUsageStats({ period, limit, type, source, mode, cutoverTs })
    //            and fetchHardwareUsageStats(period, limit, type)
    let opts = args[0];
    if (typeof opts !== 'object' || opts === null) {
      const [period, limit, type] = args;
      opts = { period, limit, type };
    }

    const {
      period = 'week',
      limit = 20,
      type = 'all',
      source = 'mysql',   // default to MySQL only
      mode = 'sum',
      cutoverTs = null
    } = opts;

    const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/hardware-usage-stats-merged`;

    try {
      const token = localStorage.getItem('jwtToken');

      // Build params (omit undefined/nulls)
      const params = {
        period,
        limit: Number(limit),
        type,
        source,
        mode
      };
      if (cutoverTs != null) params.cutoverTs = Number(cutoverTs);

      const response = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
        params
      });

      const { data } = response;
      if (data.success) {
        dispatch({ type: FETCH_HARDWARE_USAGE_STATS_SUCCESS, payload: data.data });
      } else {
        dispatch({ type: FETCH_HARDWARE_USAGE_STATS_FAIL, payload: data.message });
      }
    } catch (err) {
      const msg = err.response?.data?.message || err.message;
      dispatch({ type: FETCH_HARDWARE_USAGE_STATS_FAIL, payload: msg });
    }
  };



// Call your API here. Adjust the endpoint and parameters as needed.
export const fetchCraftedCocktailsExpand = (period, limit) => async (dispatch) => {
  dispatch({ type: FETCH_CRAFTED_COCKTAILS_EXPAND_LOADING });

  // merged endpoint
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/crafted-cocktail-expand-merged`;

  try {
    const token = localStorage.getItem("jwtToken");
    const nowSec = Math.floor(Date.now() / 1000); // cutoverTs in seconds

    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        period,                   // 'day' | 'week' | 'month' | 'year'
        limit,                    // number
        mode: 'sum',              // keep default merge logic (doesn't matter when PG is empty)
        cutoverTs: nowSec         // => MySQL-only (PG counts > now => 0)
      },
    });

    const { data } = response;
    if (data.success) {
      dispatch({ type: FETCH_CRAFTED_COCKTAILS_EXPAND_SUCCESS, payload: data.data });
    } else {
      dispatch({ type: FETCH_CRAFTED_COCKTAILS_EXPAND_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_CRAFTED_COCKTAILS_EXPAND_FAIL, payload: errorMessage });
  }
};

//Action User Tile Info for Total Registered Users Expansion Chart
export const fetchOrderDetails = ( order_id ) => async (dispatch) => {
  console.log("fetchOrderDetails action invoked with:", { order_id });
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/order-items`;
  // http://localhost:9890/secureapi/analytics/dashboard/dashboard-user-tile-info?filter=0&table=users&startTime=2023-01-01T00:00:00Z&endTime=2025-12-31T23:59:59Z&agestart=0&ageend=99
  dispatch({ type: FETCH_ORDER_DETAILS_LOADING });
  // console.log('Running fetchUserTileInfo ------------------------', apiUrl)

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params: { order_id },
    });
    
    const { data } = response;

    if (data.success) {
      console.log('FetchOrders:', data.data);
      dispatch({ type: FETCH_ORDER_DETAILS_SUCCESS, payload: data.data });
    } else {
      // console.log("User Tile Info:", data);
      dispatch({ type: FETCH_ORDER_DETAILS_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_ORDER_DETAILS_FAIL, payload: errorMessage });
  }
};

//Action User Tile Info for Total Registered Users Expansion Chart
export const fetchOrders = (dateFrom, dateTo) => async (dispatch) => {
  // console.log("fetchOrders action invoked with:", { dateFrom, dateTo });
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/orders`;
  // http://localhost:9890/secureapi/analytics/dashboard/dashboard-user-tile-info?filter=0&table=users&startTime=2023-01-01T00:00:00Z&endTime=2025-12-31T23:59:59Z&agestart=0&ageend=99
  dispatch({ type: FETCH_ORDERS_LOADING });
  // console.log('Running fetchUserTileInfo ------------------------', apiUrl)

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params: { dateFrom, dateTo },
    });
    
    const { data } = response;

    if (data.success) {
      console.log('FetchOrders:', data.data);
      dispatch({ type: FETCH_ORDERS_SUCCESS, payload: data.data });
    } else {
      // console.log("User Tile Info:", data);
      dispatch({ type: FETCH_ORDERS_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_ORDERS_FAIL, payload: errorMessage });
  }
};


//Action User Tile Info for Total Registered Users Expansion Chart
export const fetchUserTileInfo =
  (filter, table, startTime, endTime, agestart, ageend, loading_flag = 1) =>
  async (dispatch) => {
    const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/dashboard-user-tile-info`;

    if (Number(loading_flag) !== 0) {
      dispatch({ type: FETCH_USER_TILE_INFO_LOADING });
    }

    try {
      const token = localStorage.getItem("jwtToken");
      const response = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
        params: { filter, table, startTime, endTime, agestart, ageend },
      });

      const { data } = response;
      if (data.success) {
        dispatch({ type: FETCH_USER_TILE_INFO_SUCCESS, payload: data.data });
      } else {
        dispatch({ type: FETCH_USER_TILE_INFO_FAIL, payload: data.message });
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      dispatch({ type: FETCH_USER_TILE_INFO_FAIL, payload: errorMessage });
    }
  };


// Action creator for fetching Brand Mixlists
export const fetchInfluencerMixlists = (orderRank, datefilter, startTime, endTime, limit) => async (dispatch) => {
  // console.log("fetchInfluencerMixlists action invoked with:", { orderRank, datefilter, startTime, endTime, limit });
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/playlists/influencer`;
  dispatch({ type: FETCH_PLAYLIST_INFLUENCERS_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params: { orderRank, datefilter, startTime, endTime, limit },
    });
    // console.log('Running fetchInfluencerMixlists ------------------------', response)


    // console.log("Influencer mixilists API Response:", response.data);
    const { data } = response;
    if (data.success) {
      // console.log("Fetched Influencer mixilists:", data);
      dispatch({ type: FETCH_PLAYLIST_INFLUENCERS_SUCCESS, payload: data.data });
    } else {
      console.log("Fetched Influencer mixilists:", data);
      dispatch({ type: FETCH_PLAYLIST_INFLUENCERS_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_PLAYLIST_INFLUENCERS_FAIL, payload: errorMessage });
  }
};

// Action creator for fetching Brand Mixlists
export const fetchBrandMixlists = (orderRank, datefilter, startTime, endTime, limit) => async (dispatch) => {
  // console.log("fetchBrandMixlists action invoked with:", { orderRank, datefilter, startTime, endTime, limit });
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/playlists/brand`;
  dispatch({ type: FETCH_PLAYLIST_BRANDS_LOADING });
  // console.log('Running fetchplaylistmixilists ------------------------', apiUrl)

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params: { orderRank, datefilter, startTime, endTime, limit },
    });

    // console.log("brand mixilists API Response:", response.data);
    const { data } = response;
    if (data.success) {
      // console.log("Fetched brand mixilists:", data);
      dispatch({ type: FETCH_PLAYLIST_BRANDS_SUCCESS, payload: data.data });
    } else {
      console.log("Fetched brand mixilists:", data);
      dispatch({ type: FETCH_PLAYLIST_BRANDS_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_PLAYLIST_BRANDS_FAIL, payload: errorMessage });
  }
};

// Action creator for fetching Playlist Mixlists
// Fetch Mixlists (MySQL-only for now)
export const fetchPlaylistMixlists = (orderRank, datefilter, startTime, endTime, limit) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/playlists/mixlist-merged`;

  dispatch({ type: FETCH_PLAYLIST_MIXILISTS_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");

    const params = {
      orderRank,          // 'asc' | 'desc'
      datefilter,         // 0..5 (3 = custom)
      startTime,          // ISO if datefilter=3
      endTime,            // ISO if datefilter=3
      limit,              // e.g., 10
      source: 'mysql',    // << force MySQL for now
    };

    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    });

    const { data } = response;

    if (data.success) {
      // Shape stays: { mixlist: [...] } so reducer can read it
      dispatch({ type: FETCH_PLAYLIST_MIXLISTS_SUCCESS, payload: data.data });
    } else {
      dispatch({ type: FETCH_PLAYLIST_MIXLISTS_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_PLAYLIST_MIXLISTS_FAIL, payload: errorMessage });
  }
};


// Action creator for fetching user recipes
export const fetchUserRecipes = (orderRank, datefilter, startTime, endTime, limit) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/user-recipes-merged`;
  dispatch({ type: FETCH_USER_RECIPES_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params: { orderRank, datefilter, startTime, endTime, limit, source: 'mysql' },
    });

    const { data } = response;
    if (data.success) {
      dispatch({ type: FETCH_USER_RECIPES_SUCCESS, payload: data.data });
    } else {
      dispatch({ type: FETCH_USER_RECIPES_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_USER_RECIPES_FAIL, payload: errorMessage });
  }
};

// Action creator for fetching curated recipes
export const fetchCuratedRecipes = (
  orderRank,
  datefilter,
  startTime,
  endTime,
  limit,
  source = 'mysql'
) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/curated-recipes-v3-merged`;
  dispatch({ type: FETCH_CURATED_RECIPES_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params: { orderRank, datefilter, startTime, endTime, limit, source },
    });

    const { data } = response;
    if (data.success) {
      dispatch({ type: FETCH_CURATED_RECIPES_SUCCESS, payload: data.data });
    } else {
      dispatch({ type: FETCH_CURATED_RECIPES_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_CURATED_RECIPES_FAIL, payload: errorMessage });
  }
};


// Action creator for fetching brand recipes
export const fetchBrandRecipes = (orderRank, datefilter, startTime, endTime, limit) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/brand-recipes-v2`;
  dispatch({ type: FETCH_BRAND_RECIPES_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params: { orderRank, datefilter, startTime, endTime, limit },
    });

    const { data } = response;
    if (data.success) {
      dispatch({ type: FETCH_BRAND_RECIPES_SUCCESS, payload: data.data });
    } else {
      dispatch({ type: FETCH_BRAND_RECIPES_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_BRAND_RECIPES_FAIL, payload: errorMessage });
  }
};

// Compare Users – Week
export const fetchCompareUsersWeek = (limit) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/compare-users-week`;
  
  dispatch({ type: FETCH_COMPARE_USERS_WEEK_LOADING });
  
  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { limit },
    });
    const { data } = response;
    
    if (data.success) {
      dispatch({ type: FETCH_COMPARE_USERS_WEEK_SUCCESS, payload: data.data });
    } else {
      dispatch({ type: FETCH_COMPARE_USERS_WEEK_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_COMPARE_USERS_WEEK_FAIL, payload: errorMessage });
  }
};

// Compare Users – Month
export const fetchCompareUsersMonth = (limit) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/compare-users-month`;
  
  dispatch({ type: FETCH_COMPARE_USERS_MONTH_LOADING });
  
  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params: { limit },
    });
    const { data } = response;
    
    if (data.success) {
      dispatch({ type: FETCH_COMPARE_USERS_MONTH_SUCCESS, payload: data.data });
    } else {
      dispatch({ type: FETCH_COMPARE_USERS_MONTH_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_COMPARE_USERS_MONTH_FAIL, payload: errorMessage });
  }
};

// Compare Users – Year
export const fetchCompareUsersYear = (limit) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/compare-users-year`;
  
  dispatch({ type: FETCH_COMPARE_USERS_YEAR_LOADING });
  
  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params: { limit },
    });
    const { data } = response;
    
    if (data.success) {
      dispatch({ type: FETCH_COMPARE_USERS_YEAR_SUCCESS, payload: data.data });
    } else {
      dispatch({ type: FETCH_COMPARE_USERS_YEAR_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_COMPARE_USERS_YEAR_FAIL, payload: errorMessage });
  }
};

// Compare Users – Day
export const fetchCompareUsersDay = (limit) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/compare-users-day`;
  
  dispatch({ type: FETCH_COMPARE_USERS_DAY_LOADING });
  
  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params: { limit },
    });
    const { data } = response;
    
    if (data.success) {
      dispatch({ type: FETCH_COMPARE_USERS_DAY_SUCCESS, payload: data.data });
      // console.log('USERS DAILY DATA:', data.data)
    } else {
      dispatch({ type: FETCH_COMPARE_USERS_DAY_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_COMPARE_USERS_DAY_FAIL, payload: errorMessage });
  }
};

// This action uses redux-thunk for asynchronous API fetching with token
export const fetchInfluencerV3 = (orderRank, datefilter, filter, startTime, endTime, limit) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/influencers-v3`;

  dispatch({ type: FETCH_INFLUENCER_V3_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { orderRank, datefilter, filter, startTime, endTime, limit },
    });

    const { data } = response;

    if (data.success) {
      dispatch({
        type: FETCH_INFLUENCER_V3_SUCCESS,
        payload: data.data,
      });
    } else {
      dispatch({
        type: FETCH_INFLUENCER_V3_FAIL,
        payload: data.message,
      });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_INFLUENCER_V3_FAIL, payload: errorMessage });
  }
};

// Action to fetch brands v3 statistics
export const fetchBrandsV3 = (orderRank, datefilter, filter, startTime, endTime, limit) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/brands-v3`;

  dispatch({ type: FETCH_BRANDS_V3_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        orderRank,
        datefilter,
        filter,
        startTime,
        endTime,
        limit
      },
    });

    const { data } = response;

    if (data.success) {
      // data.data is expected to be an array of records like the sample provided
      dispatch({ type: FETCH_BRANDS_V3_SUCCESS, payload: data.data });
    } else {
      dispatch({ type: FETCH_BRANDS_V3_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_BRANDS_V3_FAIL, payload: errorMessage });
  }
};

// Action to fetch Q1 dashboard statistics
export const fetchDashboardStatsQ1 = (loading_flag = 1) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/dashboardstatsv2-q1`;

  if (Number(loading_flag) !== 0) {
    dispatch({ type: FETCH_DASHBOARD_STATS_LOADING_Q1 });
  }

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const { data } = response;
    if (data.success) {
      dispatch({ type: FETCH_DASHBOARD_STATS_SUCCESS_Q1, payload: data.data });
    } else {
      dispatch({ type: FETCH_DASHBOARD_STATS_FAIL_Q1, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_DASHBOARD_STATS_FAIL_Q1, payload: errorMessage });
  }
};


// Action to fetch Q2 dashboard statistics
export const fetchDashboardStatsQ2 = () => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/dashboardstatsv2-q2`;

  dispatch({ type: FETCH_DASHBOARD_STATS_LOADING_Q2 });

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const { data } = response;
    if (data.success) {
      dispatch({ type: FETCH_DASHBOARD_STATS_SUCCESS_Q2, payload: data.data });
    } else {
      dispatch({ type: FETCH_DASHBOARD_STATS_FAIL_Q2, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_DASHBOARD_STATS_FAIL_Q2, payload: errorMessage });
  }
};

// Action to fetch Q3 dashboard statistics (MERGED; MySQL by default)
export const fetchDashboardStatsQ3 = (loading_flag = 1) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/dashboardstatsv2-q3-merged`;

  if (Number(loading_flag) !== 0) {
    dispatch({ type: FETCH_DASHBOARD_STATS_LOADING_Q3 });
  }

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params: { source: 'mysql' },
    });

    const { data } = response;
    if (data.success) {
      dispatch({ type: FETCH_DASHBOARD_STATS_SUCCESS_Q3, payload: data.data });
    } else {
      dispatch({ type: FETCH_DASHBOARD_STATS_FAIL_Q3, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_DASHBOARD_STATS_FAIL_Q3, payload: errorMessage });
  }
};

// Action to fetch recipes statistics
export const fetchRecipesStats = () => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/recipes-all-stats`;

  dispatch({ type: FETCH_RECIPES_STATS_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const { data } = response;

    if (data.success) {
      dispatch({ type: FETCH_RECIPES_STATS_SUCCESS, payload: data.data });
    } else {
      dispatch({ type: FETCH_RECIPES_STATS_FAIL, payload: data.message });
    }
  } catch (error) {
    console.error("Error fetching recipes stats:", error);
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_RECIPES_STATS_FAIL, payload: errorMessage });
  }
};

// Action to fetch custom recipes statistics with params
export const fetchCustomRecipesStats = (startTime, endTime, offset, orderRank) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/custom-recipes-stats`;

  dispatch({ type: FETCH_CUSTOM_RECIPES_STATS_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        startTime,
        endTime,
        offset,
        orderRank,
      },
    });

    const { data } = response;

    if (data.success) {
      dispatch({ type: FETCH_CUSTOM_RECIPES_STATS_SUCCESS, payload: data.data });
    } else {
      dispatch({ type: FETCH_CUSTOM_RECIPES_STATS_FAIL, payload: data.message });
    }
  } catch (error) {
    console.error("Error fetching custom recipes stats:", error);
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_CUSTOM_RECIPES_STATS_FAIL, payload: errorMessage });
  }
};

// Action to fetch recipes statistics with params
export const fetchRecipesStatsWithParams = (startTime, endTime, offset, orderRank) => async (dispatch) => {
    const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/recipes-stats`;
  
    dispatch({ type: FETCH_RECIPES_STATS_WITH_PARAMS_LOADING }); // Start loading
  
    try {
      const token = localStorage.getItem("jwtToken");
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          startTime,
          endTime,
          offset,
          orderRank,
        },
      });
  
      const { data } = response;
  
      if (data.success) {
        dispatch({ type: FETCH_RECIPES_STATS_WITH_PARAMS_SUCCESS, payload: data.data });
      } else {
        dispatch({ type: FETCH_RECIPES_STATS_WITH_PARAMS_FAIL, payload: data.message });
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      dispatch({ type: FETCH_RECIPES_STATS_WITH_PARAMS_FAIL, payload: errorMessage });
    }
};

// Action to fetch device recipes statistics with params
export const fetchDeviceRecipesStats = (startTime, endTime, offset, orderRank) => async (dispatch) => {
    const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/device-recipes-stats`;
  
    dispatch({ type: FETCH_DEVICE_RECIPES_STATS_LOADING }); // Start loading
  
    try {
      const token = localStorage.getItem("jwtToken");
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          startTime,
          endTime,
          offset,
          orderRank,
        },
      });
  
      const { data } = response;
  
      if (data.success) {
        dispatch({ type: FETCH_DEVICE_RECIPES_STATS_SUCCESS, payload: data.data });
      } else {
        dispatch({ type: FETCH_DEVICE_RECIPES_STATS_FAIL, payload: data.message });
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      dispatch({ type: FETCH_DEVICE_RECIPES_STATS_FAIL, payload: errorMessage });
    }
};
  
// Action to fetch curated recipes tile information with search parameters
export const fetchCuratedRecipesTileInfoSearch = (searchterm, orderRank, datefilter, startTime, endTime) => async (dispatch) => {
    const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/curated-recipes-tile-info-search`;
  
    dispatch({ type: FETCH_CURATED_RECIPES_TILE_SEARCH_LOADING }); // Start loading
  
    try {
      const token = localStorage.getItem("jwtToken");
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          searchterm,
          orderRank,
          datefilter,
          startTime,
          endTime,
        },
      });
  
      const { data } = response;
  
      if (data.success) {
        dispatch({ type: FETCH_CURATED_RECIPES_TILE_SEARCH_SUCCESS, payload: data.data });
      } else {
        dispatch({ type: FETCH_CURATED_RECIPES_TILE_SEARCH_FAIL, payload: data.message });
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      dispatch({ type: FETCH_CURATED_RECIPES_TILE_SEARCH_FAIL, payload: errorMessage });
    }
};

// Action to fetch ingredients tile information with search parameters
export const fetchIngredientsTileInfoSearch = (searchterm, orderRank, datefilter, startTime, endTime) => async (dispatch) => {
    const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/ingredients-tile-info-search`;
  
    dispatch({ type: FETCH_INGREDIENTS_TILE_SEARCH_LOADING }); // Start loading
  
    try {
      const token = localStorage.getItem("jwtToken");
  
      // Make the API call with parameters and the Authorization header
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          searchterm,
          orderRank,
          datefilter,
          startTime,
          endTime,
        },
      });
  
      const { data } = response;
  
      if (data.success) {
        dispatch({ type: FETCH_INGREDIENTS_TILE_SEARCH_SUCCESS, payload: data.data });
      } else {
        dispatch({ type: FETCH_INGREDIENTS_TILE_SEARCH_FAIL, payload: data.message });
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      dispatch({ type: FETCH_INGREDIENTS_TILE_SEARCH_FAIL, payload: errorMessage });
    }
};

// Action to fetch brands tile information with search parameters
export const fetchBrandsTileInfoSearch = (searchterm, orderRank, datefilter, startTime, endTime) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/brands-tile-info-search`;

  dispatch({ type: FETCH_BRANDS_TILE_SEARCH_LOADING }); // Begin loading

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        searchterm,
        orderRank,
        datefilter,
        startTime,
        endTime,
      },
    });

    const { data } = response;
    if (data.success) {
      dispatch({ type: FETCH_BRANDS_TILE_SEARCH_SUCCESS, payload: data.data });
    } else {
      dispatch({ type: FETCH_BRANDS_TILE_SEARCH_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_BRANDS_TILE_SEARCH_FAIL, payload: errorMessage });
  }
};

// Action for fetching influencers tile information
export const fetchInfluencersTileInfoSearch = (searchterm, orderRank, datefilter, startTime, endTime) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/influencers-tile-info-search`;

  dispatch({ type: FETCH_INFLUENCERS_TILE_SEARCH_LOADING }); // Begin loading

  try {
    const token = localStorage.getItem('jwtToken');
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        searchterm,
        orderRank,
        datefilter,
        startTime,
        endTime,
      },
    });

    const { data } = response;
    if (data.success) {
      dispatch({ type: FETCH_INFLUENCERS_TILE_SEARCH_SUCCESS, payload: data.data });
    } else {
      dispatch({ type: FETCH_INFLUENCERS_TILE_SEARCH_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_INFLUENCERS_TILE_SEARCH_FAIL, payload: errorMessage });
  }
};

// Action for fetching influencer recipes
export const fetchInfluencerRecipes = (orderRank, datefilter, startTime, endTime, limit) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/influencer-recipes`;

  dispatch({ type: FETCH_INFLUENCER_RECIPES_LOADING }); // Begin loading

  try {
    const token = localStorage.getItem('jwtToken');
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        orderRank,
        datefilter,
        startTime,
        endTime,
        limit
      },
    });

    const { data } = response;
    if (data.success) {
      dispatch({ type: FETCH_INFLUENCER_RECIPES_SUCCESS, payload: data.data });
    } else {
      dispatch({ type: FETCH_INFLUENCER_RECIPES_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_INFLUENCER_RECIPES_FAIL, payload: errorMessage });
  }
};

export const fetchCuratedRecipesV3 = (
  orderRank,
  datefilter,
  filter,
  startTime,
  endTime,
  limit
) => async (dispatch) => {
  // merged endpoint (MySQL only for now)
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/curated-recipes-v3-merged`;

  const toIso = (d) => new Date(d).toISOString();
  const startISOString = toIso(startTime);
  const endISOString = toIso(endTime);

  dispatch({ type: FETCH_CURATED_RECIPES_V3_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        orderRank,
        datefilter,
        filter,
        startTime: startISOString,
        endTime: endISOString,
        limit,
        source: "mysql" // <-- force MySQL
      },
    });

    const { data } = response;
    if (data.success) {
      dispatch({ type: FETCH_CURATED_RECIPES_V3_SUCCESS, payload: data.data });
    } else {
      dispatch({ type: FETCH_CURATED_RECIPES_V3_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_CURATED_RECIPES_V3_FAIL, payload: errorMessage });
  }
};

export const fetchIngredientsV4 = (optsOrOrder = {}, maybeLimit, maybeSource) => async (dispatch) => {
  let orderRank = 'desc', limit = 10, source = 'mysql';

  if (typeof optsOrOrder === 'object' && optsOrOrder !== null) {
    ({ orderRank = 'desc', limit = 10, source = 'mysql' } = optsOrOrder);
  } else {
    orderRank = optsOrOrder ?? 'desc';
    limit = maybeLimit ?? 10;
    source = maybeSource ?? 'mysql';
  }

  dispatch({ type: FETCH_INGREDIENTS_V3_LOADING });
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/ingredient-data-v4-merged`;

  const token = localStorage.getItem('jwtToken');
  const params = { orderRank, limit, source };
  const response = await axios.get(apiUrl, { headers: { Authorization: `Bearer ${token}` }, params });
  const { data } = response;

  if (data.success) {
    dispatch({ type: FETCH_INGREDIENTS_V3_SUCCESS, payload: data.data });
  } else {
    dispatch({ type: FETCH_INGREDIENTS_V3_FAIL, payload: data.message });
  }
};


  export const fetchStatsDataJson = () => async (dispatch) => {
    const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/stats-data-json`;

    // Dispatch the loading action:
    dispatch({ type: FETCH_STATS_DATA_JSON_LOADING });

    try {
      const token = localStorage.getItem("jwtToken");
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const { data } = response;

      if (data.success) {
        // Dispatch success action with the fetched data:
        dispatch({ type: FETCH_STATS_DATA_JSON_SUCCESS, payload: data.data });
      } else {
        // Dispatch failure action with the API error message:
        dispatch({ type: FETCH_STATS_DATA_JSON_FAIL, payload: data.message });
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      // Dispatch failure action with the error message:
      dispatch({ type: FETCH_STATS_DATA_JSON_FAIL, payload: errorMessage });
    }
  };

  export const fetchCountryDataJson = () => async (dispatch) => {
    const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/country-data-json`;

    // Dispatch the loading action
    dispatch({ type: FETCH_COUNTRY_DATA_JSON_LOADING });

    try {
      const token = localStorage.getItem("jwtToken");
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const { data } = response;

      if (data.success) {
        // On success, dispatch the retrieved data
        dispatch({ type: FETCH_COUNTRY_DATA_JSON_SUCCESS, payload: data.data });
      } else {
        // If the response indicates a problem, dispatch the failure action with the message
        dispatch({ type: FETCH_COUNTRY_DATA_JSON_FAIL, payload: data.message });
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      // Dispatch failure in case of an error
      dispatch({ type: FETCH_COUNTRY_DATA_JSON_FAIL, payload: errorMessage });
    }
  };

export const fetchSourceDataJson = () => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/source-data-json`;

  // Dispatch the loading action:
  dispatch({ type: FETCH_SOURCE_DATA_JSON_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const { data } = response;

    if (data.success) {
      // On success, dispatch the retrieved data:
      dispatch({ type: FETCH_SOURCE_DATA_JSON_SUCCESS, payload: data.data });
    } else {
      // If the API response signals an error, dispatch the failure action with the message:
      dispatch({ type: FETCH_SOURCE_DATA_JSON_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    // Dispatch failure with the error message in case of an error:
    dispatch({ type: FETCH_SOURCE_DATA_JSON_FAIL, payload: errorMessage });
  }
};

export const fetchProductDataJson = () => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/product-data-json`;
  
  // Dispatch the loading action:  
  dispatch({ type: FETCH_PRODUCT_DATA_JSON_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const { data } = response;

    if (data.success) {
      // Dispatch the success action with the data
      dispatch({ type: FETCH_PRODUCT_DATA_JSON_SUCCESS, payload: data.data });
    } else {
      // Dispatch the failure action with the error message from API
      dispatch({ type: FETCH_PRODUCT_DATA_JSON_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    // Dispatch the failure action with the caught error message
    dispatch({ type: FETCH_PRODUCT_DATA_JSON_FAIL, payload: errorMessage });
  }
};

export const fetchHardwareChartTileInfo = (loading_flag = 1) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureapi/analytics/dashboard/hardware-chart-tile-info-v3`;

  if (Number(loading_flag) !== 0) {
    dispatch({ type: FETCH_HARDWARE_CHART_TILE_INFO_LOADING });
  }

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const { data } = response;
    if (data.success) {
      dispatch({ type: FETCH_HARDWARE_CHART_TILE_INFO_SUCCESS, payload: data.data });
    } else {
      dispatch({ type: FETCH_HARDWARE_CHART_TILE_INFO_FAIL, payload: data.message });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({ type: FETCH_HARDWARE_CHART_TILE_INFO_FAIL, payload: errorMessage });
  }
};
